import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage } from "../i18n";

export const FinalCta = () => {
  const { t } = useLanguage();
  return (
    <section className="noise-overlay relative overflow-hidden bg-petrolio py-24 text-avorio sm:py-28" data-testid="final-cta-section">
      <svg
        className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 text-salvia/15"
        viewBox="0 0 200 200"
        aria-hidden="true"
      >
        <circle cx="100" cy="100" r="98" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="100" cy="100" r="70" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="100" cy="100" r="42" fill="none" stroke="currentColor" strokeWidth="1.5" />
      </svg>
      <svg
        className="pointer-events-none absolute -bottom-28 -left-20 h-80 w-80 text-salvia/10"
        viewBox="0 0 200 200"
        aria-hidden="true"
      >
        <path d="M20 180 L20 90 L100 140 L100 40" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="100" cy="40" r="8" fill="currentColor" />
      </svg>

      <div className="relative mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal>
          <p className="eyebrow !text-salvia">{t("Iniziamo")}</p>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            {t("La tua prossima opportunità digitale potrebbe iniziare oggi.")}
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-avorio/75 sm:text-lg">
            {t("Raccontaci la tua idea. Troviamo insieme la soluzione più adatta per trasformarla in un progetto concreto.")}
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <Link
              to="/prenota"
              data-testid="final-cta-booking"
              className="inline-flex items-center gap-2 rounded-full bg-avorio px-7 py-3.5 text-sm font-semibold text-petrolio shadow-lg transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-xl active:scale-[0.98]"
            >
              {t("Prenota una consulenza")}
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/contatti"
              data-testid="final-cta-quote"
              className="inline-flex items-center gap-2 rounded-full border border-salvia/50 px-7 py-3.5 text-sm font-semibold text-avorio transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-salvia/15 active:scale-[0.98]"
            >
              <FileText className="h-4 w-4" />
              {t("Richiedi un preventivo")}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
